function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react';
import { createBrowserHistory, createHashHistory } from 'history';
import { Router, StaticRouter } from 'react-router-dom';
import { createPlugin, RuntimeReactContext } from '@modern-js/runtime-core';
import { resolveBasename, renderRoutes, getLocation } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";

// todo: check
var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

export var routerPlugin = function routerPlugin(_ref) {
  var customHistory = _ref.history,
      _ref$supportHtml5Hist = _ref.supportHtml5History,
      supportHtml5History = _ref$supportHtml5Hist === void 0 ? true : _ref$supportHtml5Hist,
      routesConfig = _ref.routesConfig,
      historyOptions = _ref.historyOptions;
  var isBrow = isBrowser(); // eslint-disable-next-line no-nested-ternary

  var history = isBrow ? customHistory || supportHtml5History ? createBrowserHistory(historyOptions) : createHashHistory(historyOptions) : {};
  return createPlugin(function () {
    return {
      hoc: function hoc(_ref2, next) {
        var App = _ref2.App;

        var getRouteApp = function getRouteApp() {
          if (isBrow) {
            return function (props) {
              return /*#__PURE__*/_jsx(Router, {
                history: history,
                children: routesConfig ? renderRoutes(routesConfig, props) : /*#__PURE__*/_jsx(App, _objectSpread({}, props))
              });
            };
          }

          return function (props) {
            var _runtimeContext$ssrCo;

            var runtimeContext = useContext(RuntimeReactContext);
            var basename = resolveBasename(historyOptions === null || historyOptions === void 0 ? void 0 : historyOptions.basename);
            var location = getLocation(runtimeContext === null || runtimeContext === void 0 ? void 0 : runtimeContext.ssrContext);
            var ctx = (runtimeContext === null || runtimeContext === void 0 ? void 0 : (_runtimeContext$ssrCo = runtimeContext.ssrContext) === null || _runtimeContext$ssrCo === void 0 ? void 0 : _runtimeContext$ssrCo.redirection) || {};
            return /*#__PURE__*/_jsx(StaticRouter, {
              basename: basename,
              location: location,
              context: ctx,
              children: routesConfig ? renderRoutes(routesConfig, props) : /*#__PURE__*/_jsx(App, _objectSpread({}, props))
            });
          };
        };

        return next({
          App: getRouteApp()
        });
      }
    };
  }, {
    name: "@modern-js/plugin-router"
  });
};